module.exports = __webpack_public_path__ + "static/media/B&TScreenshot3.767a5464.png";